import { MediaDurationService } from "@/application/upload/ports/MediaDurationService";

export class BrowserMediaDurationService implements MediaDurationService {
  async getDuration(file: File): Promise<number> {
    const extension = this.extractExtension(file.name);

    if (extension === "amr") {
      return this.calculateAmrDuration(file);
    }

    return this.loadDurationViaMediaElement(file);
  }

  private extractExtension(fileName: string): string {
    return fileName.split(".").pop()?.toLowerCase() ?? "";
  }

  private calculateAmrDuration(file: File): number {
    const fileSizeInBits = file.size * 8;
    const bitRate = 12200; // 12.2 kbit/s for AMR-NB
    return fileSizeInBits / bitRate;
  }

  private loadDurationViaMediaElement(file: File): Promise<number> {
    return new Promise((resolve, reject) => {
      const mediaElement = document.createElement(
        file.type.startsWith("video/") ? "video" : "audio"
      );
      const objectUrl = URL.createObjectURL(file);

      const cleanup = () => {
        URL.revokeObjectURL(objectUrl);
        mediaElement.remove();
      };

      mediaElement.preload = "metadata";
      mediaElement.src = objectUrl;

      const handleLoadedMetadata = () => {
        const duration = mediaElement.duration;
        cleanup();
        if (Number.isFinite(duration)) {
          resolve(duration);
        } else {
          reject(new Error("Invalid media duration"));
        }
      };

      const handleError = () => {
        cleanup();
        reject(new Error("Failed to load media metadata"));
      };

      mediaElement.addEventListener("loadedmetadata", handleLoadedMetadata, {
        once: true,
      });
      mediaElement.addEventListener("error", handleError, { once: true });
    });
  }
}

